import { FormlyFieldConfig } from '@ngx-formly/core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import {
  AppState,
  formSchemaSelector,
  selectSpecificformSchemaSelector,
  dropdownOptionsSelector,
  intakeSectionSelector
} from '..';
import { FetchFormSchema, FetchDropdownOptions } from './form-schema.actions';

@Injectable({
  providedIn: 'root'
})

export class FormSchemaFacade {
  formlySchema$: Observable<AppState['form_schema']>;
  dropdownOption$: Observable<AppState['dropdown_options']>;

  constructor(private store: Store<AppState>) {
      this.formlySchema$ = store.pipe(select(formSchemaSelector));
      this.dropdownOption$ = store.pipe(select(dropdownOptionsSelector));
  }

  getFormSchema(id: string) {
    this.store.dispatch(new FetchFormSchema(id));
  }

  selectSpecifySchema(parentSection: string, subSection: string) {
    return this.store.pipe(select(selectSpecificformSchemaSelector, { parentSection, subSection }));
  }

  getDropdownOptions() {
    this.store.dispatch(new FetchDropdownOptions());
  }

  getIntakeSections() {
    return this.store.pipe(select(intakeSectionSelector));
  }

}
